import React, { useEffect } from "react";
import { useSyncContext } from "~/hooks/useSyncContext";
import LoaderFull from "~/components/Form/components/LoaderFull";
import { Spinner } from "@chakra-ui/react";
import { isTablet } from "react-device-detect";
import "./SyncLoadingFullScreen.scss";

// Mapeamento de URLs de APIs para nomes de contexto amigáveis
const getContextName = (apiUrl) => {
  if (!apiUrl) return "Dados";

  const urlMap = {
    "/api/MapaMina": "Mapa da Mina",
    "/api/TabelaPreco": "Tabela de Preço",
    "/api/BackOffice": "Backoffice",
    "/api/Cadastro": "Cadastro",
    "/api/Produtos": "Produtos",
    "/api/Clientes": "Clientes",
    "/api/Simulador": "Simulador",
    "/api/FunilObra": "Funil de Obra",
    "/api/Gestao": "Gestão",
    "/api/Relatorios": "Relatórios",
    "/api/Visitas": "Visitas",
  };

  if (urlMap[apiUrl]) {
    return urlMap[apiUrl];
  }

  const match = apiUrl.match(/\/api\/([^/?]+)/);
  if (match) {
    const endpoint = match[1];
    return urlMap[`/api/${endpoint}`] || endpoint;
  }

  return apiUrl || "Dados";
};

const SyncLoadingFullScreen = () => {
  const { isProcessing, message, currentRequest, progressPercentage } = useSyncContext();

  useEffect(() => {
    if (isProcessing) {
      document.body.classList.add("sync-processing");

      const preventKeys = (e) => {
        if (e.key === "F5" || (e.ctrlKey && e.key === "r") || e.key === "Escape") {
          e.preventDefault();
          return false;
        }
      };

      document.addEventListener("keydown", preventKeys);

      return () => {
        document.body.classList.remove("sync-processing");
        document.removeEventListener("keydown", preventKeys);
      };
    }
  }, [isProcessing]);

  if (!isProcessing) return null;

  return (
    <div className="sync-loading-wrapper">
      <LoaderFull activeMessage={false} />

      <div className="synchronize-loading-container">
        <div className="content">
          <Spinner color="#034EA2" size={"xl"} thickness="4px" />

          <h2 className="title" data-test-id="modal-offline-sync-loader">Sincronizando dados offline...</h2>

          {isTablet && (
            <p className="text-red-600 font-semibold text-sm mb-2">
              NÃO desligue ou bloqueie a tela do tablet durante a sincronização
            </p>
          )}

          <div className="progress-bar">
            <div className="bar" style={{ width: `${Math.min(progressPercentage, 99)}%` }}></div>
            <span className="desc" style={{ left: `${Math.min(progressPercentage, 99)}%` }}>
              {Math.min(progressPercentage, 99)}%
            </span>
          </div>

          {message && <div className="text-[#034EA2] text-center mt-2 font-medium">{message}</div>}

          {currentRequest && (
            <div className="text-[#034EA2] relative px-4 py-2 rounded mt-4 after:content-[''] after:block after:h-[2px] after:w-1/2 after:bg-[#034EA2] after:absolute after:bottom-0 after:left-1/4">
              Processando: {getContextName(currentRequest)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SyncLoadingFullScreen;
